// Build A Crate Interactions
document.addEventListener('DOMContentLoaded', function() {
  // Initialize namespace
  if (typeof window.buildACrateFlow === 'undefined') {
    window.buildACrateFlow = {
      allPlanCards: [],
      matchingPlanCards: [],
      planCardsByKey: {},
      spType: '',
      requestedSpType: '',
      shipFrequency: '',
      shipFrequencyNum: null
    };
  } else {
    if (!Array.isArray(window.buildACrateFlow.allPlanCards)) {
      window.buildACrateFlow.allPlanCards = [];
    }
    if (!Array.isArray(window.buildACrateFlow.matchingPlanCards)) {
      window.buildACrateFlow.matchingPlanCards = [];
    }
    if (!window.buildACrateFlow.planCardsByKey || typeof window.buildACrateFlow.planCardsByKey !== 'object') {
      window.buildACrateFlow.planCardsByKey = {};
    }
  }

  function refreshAtcSubmitState() {
    if (window.buildACrateFlow.updateBuildACrateSubmitState) {
      window.buildACrateFlow.updateBuildACrateSubmitState();
    }
  }

  var dom = window.BuildACrateDom;
  if (!dom) {
    console.error('[Build A Crate] build-a-crate-cart.js failed to initialize BuildACrateDom');
  }

  // Debug: opt-in via window.buildACrateFlow.debug = true or ?bac_debug=1
  var bacDebugEnabled = window.buildACrateFlow.debug === true ||
    (typeof URLSearchParams !== 'undefined' &&
      new URLSearchParams(window.location.search).get('bac_debug') === '1');

  function bacDebugLog(title, payload) {
    if (!bacDebugEnabled) return;
    if (payload !== undefined) {
      console.log('[Build A Crate]', title, payload);
    } else {
      console.log('[Build A Crate]', title);
    }
  }

  function getPlanCards() {
    return document.querySelectorAll('[data-plan-card]');
  }

  function collectAddedAddons() {
    var added = [];
    dom.queryAddons({}).forEach(function(el) {
      var isAdded = el.getAttribute('data-added') === 'true';
      var nameEl = el.querySelector('[data-bac-addon-name]');
      added.push({
        itemId: el.getAttribute('data-item-id') || '',
        itemType: el.getAttribute('data-item-type') || '',
        name: nameEl ? nameEl.textContent.trim() : '',
        added: isAdded
      });
    });
    return added;
  }

  function getPlanCardLabel(card) {
    var body = getPlanProductBodyForMode(card, getPurchaseMode());
    if (!body) {
      body = card.querySelector('[data-bac-plan-body]');
    }
    if (!body) return '';
    var titleEl = body.querySelector('[data-bac-plan-title]');
    return titleEl ? titleEl.textContent.trim() : '';
  }

  /**
   * Shipping frequency is stored as strings in theme JSON / radio values ("1", "2", "3").
   * Plan cards expose data-sp-frequency as numbers in HTML — always normalize before compare.
   */
  function normalizeShipFrequency(freq) {
    if (freq === null || freq === undefined) return NaN;
    var parsed = parseInt(String(freq).trim(), 10);
    return Number.isFinite(parsed) ? parsed : NaN;
  }

  function cardMatchesPlanFilter(card, requestedSpType, shipFrequency) {
    if (!card || !requestedSpType) return false;
    var expectedShip = normalizeShipFrequency(shipFrequency);
    var cardShip = normalizeShipFrequency(card.getAttribute('data-sp-frequency'));
    if (!Number.isFinite(expectedShip) || !Number.isFinite(cardShip)) return false;
    var cardSp = (card.getAttribute('data-sp-type') || '').trim();
    return cardSp === String(requestedSpType).trim() && cardShip === expectedShip;
  }

  window.buildACrateFlow.normalizeShipFrequency = normalizeShipFrequency;

  /**
   * Configured for checkout = active purchase mode has a product body in its plan view.
   * data-plan-card-unconfigured only means "no product at all in Liquid" — not mode-aware.
   */
  function isPlanCardConfiguredForPurchaseMode(card, mode) {
    if (!card) return false;
    mode = mode || getPurchaseMode();
    var view = card.querySelector('[data-bac-plan-view="' + mode + '"]');
    if (!view) return false;
    return !!view.querySelector('[data-bac-plan-body][data-bac-plan-product-id]');
  }

  function getPlanProductBodyForMode(card, mode) {
    if (!card) return null;
    mode = mode || getPurchaseMode();
    var view = card.querySelector('[data-bac-plan-view="' + mode + '"]');
    if (view) {
      var body = view.querySelector('[data-bac-plan-body][data-bac-plan-product-id]');
      if (body) return body;
    }
    return card.querySelector('[data-bac-plan-view] [data-bac-plan-body][data-bac-plan-product-id]');
  }

  window.buildACrateFlow.isPlanCardConfiguredForPurchaseMode = isPlanCardConfiguredForPurchaseMode;

  function planCardMapKey(spType, shipFrequencyNum) {
    return String(spType || '').trim() + '|' + shipFrequencyNum;
  }

  function syncPlanCardsToBuildACrateFlow(requestedSpType, shipFrequency, rows) {
    var flow = window.buildACrateFlow;
    var shipFrequencyNum = normalizeShipFrequency(shipFrequency);
    var activeSpType = String(requestedSpType || '').trim();

    flow.allPlanCards = rows;
    flow.spType = activeSpType;
    flow.requestedSpType = activeSpType;
    if (Number.isFinite(shipFrequencyNum)) {
      flow.shipFrequency = String(shipFrequencyNum);
      flow.shipFrequencyNum = shipFrequencyNum;
    }
    flow.planFilterKey = planCardMapKey(activeSpType, shipFrequencyNum);
    flow.matchingPlanCards = rows.filter(function(c) { return c.matchesFilter; });

    var byKey = {};
    rows.forEach(function(c) {
      var key = planCardMapKey(c.spType, c.shipFrequencyNum != null ? c.shipFrequencyNum : normalizeShipFrequency(c.shipFrequency));
      if (!byKey[key]) byKey[key] = [];
      byKey[key].push(c);
    });
    flow.planCardsByKey = byKey;
    bacDebugLog('plan-cards-sync', { spType: activeSpType, shipFrequencyNum: shipFrequencyNum });
  }

  function collectPlanCardsState(requestedSpType, shipFrequency) {
    var purchaseMode = getPurchaseMode();
    var activeSpType = String(requestedSpType || getActiveSpType() || '').trim();
    var activeShipFrequency = shipFrequency;
    if (activeShipFrequency === undefined || activeShipFrequency === null || activeShipFrequency === '') {
      activeShipFrequency = getSelectedShipFrequency();
    }
    var rows = [];
    getPlanCards().forEach(function(card, index) {
      var body = getPlanProductBodyForMode(card, purchaseMode);
      var spType = card.getAttribute('data-sp-type') || '';
      var cardShipRaw = card.getAttribute('data-sp-frequency') || '';
      var cardShipNum = normalizeShipFrequency(cardShipRaw);
      var matchesFilter = cardMatchesPlanFilter(card, activeSpType, activeShipFrequency);
      var configuredForMode = isPlanCardConfiguredForPurchaseMode(card, purchaseMode);
      rows.push({
        index: index,
        spType: spType,
        shipFrequency: cardShipRaw,
        shipFrequencyNum: Number.isFinite(cardShipNum) ? cardShipNum : null,
        payFrequency: card.getAttribute('data-pay-frequency') || '',
        matchesFilter: matchesFilter,
        visible: !dom.isHidden(card),
        selected: dom.isPlanSelected(card),
        unconfigured: card.hasAttribute('data-plan-card-unconfigured'),
        configuredForMode: configuredForMode,
        purchaseMode: purchaseMode,
        buyOnceHandleFallback: card.getAttribute('data-bac-buy-once-handle') || '',
        subscribeHandleFallback: card.getAttribute('data-bac-subscribe-handle') || '',
        productHandle: body ? body.getAttribute('data-bac-plan-product-handle') || '' : '',
        title: getPlanCardLabel(card),
        activeSpType: activeSpType,
        activeShipFrequency: Number.isFinite(normalizeShipFrequency(activeShipFrequency))
          ? normalizeShipFrequency(activeShipFrequency)
          : null
      });
    });
    syncPlanCardsToBuildACrateFlow(activeSpType, activeShipFrequency, rows);
    return rows;
  }

  function logPlanFilterState(trigger, extra) {
    if (!bacDebugEnabled) return;

    try {
      var addedAddons = collectAddedAddons();
      var addedOnly = addedAddons.filter(function(a) { return a.added; });
      var purchaseMode = getPurchaseMode();
      var requestedSpType = getActiveSpType();
      var shipFrequency = getSelectedShipFrequency();
      var shipFrequencyNum = normalizeShipFrequency(shipFrequency);
      var allCards = collectPlanCardsState(requestedSpType, shipFrequency);
      var matchingFilter = allCards.filter(function(c) { return c.matchesFilter; });
      var visibleCards = allCards.filter(function(c) { return c.visible; });
      var matchingConfigured = matchingFilter.filter(function(c) { return c.configuredForMode; });
      var matchingVisibleConfigured = visibleCards.filter(function(c) { return c.configuredForMode; });

      var report = {
        trigger: trigger || 'plan-filter',
        triggerDetail: extra || null,
        addedAddons: addedOnly,
        allAddons: addedAddons,
        expectedSpType: requestedSpType,
        shipFrequency: shipFrequency,
        shipFrequencyNum: Number.isFinite(shipFrequencyNum) ? shipFrequencyNum : null,
        purchaseMode: purchaseMode,
        matchingFilterCount: matchingFilter.length,
        matchingFilterCards: matchingFilter,
        matchingConfiguredCount: matchingConfigured.length,
        visiblePlanCardCount: visibleCards.length,
        visiblePlanCards: visibleCards,
        visibleConfiguredCount: matchingVisibleConfigured.length,
        allPlanCards: allCards
      };

      console.group('[Build A Crate] ' + (trigger || 'plan-filter'));
      console.log('Summary (copy this object):', report);
      console.log('Filter: sp_type ===', requestedSpType, 'AND sp_frequency (num) ===', shipFrequencyNum);
      console.log('Matching allCards (should equal visible):', matchingFilter.length, matchingFilter);
      console.log('Configured in match (for purchase mode "' + purchaseMode + '"):', matchingConfigured.length, matchingConfigured);
      console.log('Added add-ons:', addedOnly);
    if (matchingFilter.length === 0) {
      console.warn('[Build A Crate] No plan card blocks match sp_type + sp_frequency.', {
        expectedSpType: requestedSpType,
        shipFrequency: shipFrequency,
        allCardsByType: allCards.reduce(function(acc, c) {
          var key = c.spType + '|' + c.shipFrequency;
          acc[key] = (acc[key] || 0) + 1;
          return acc;
        }, {})
      });
    } else if (matchingConfigured.length === 0) {
      console.warn(
        '[Build A Crate] Cards match sp_type + sp_frequency but none have a product for purchase mode "' +
          purchaseMode + '".',
        matchingFilter
      );
    }
      console.table(allCards);
      console.groupEnd();
    } catch (err) {
      console.error('[Build A Crate] Debug log failed:', err);
    }
  }

  window.buildACrateFlow.logPlanFilterState = logPlanFilterState;
  window.buildACrateFlow.collectPlanCardsState = collectPlanCardsState;
  window.buildACrateFlow.syncPlanCardsToBuildACrateFlow = syncPlanCardsToBuildACrateFlow;
  window.buildACrateFlow.planCardMapKey = planCardMapKey;

  var crateRoot = document.querySelector('[data-build-a-crate-single]');
  var bacMainGallery = crateRoot ? crateRoot.querySelector('.bac-product-carousel') : null;
  var bacThumbGallery = crateRoot ? crateRoot.querySelector('.bac-product-thumbnails') : null;
  var bacMainGalleryWrapper = bacMainGallery ? bacMainGallery.querySelector('.swiper-wrapper') : null;
  var bacThumbGalleryWrapper = bacThumbGallery ? bacThumbGallery.querySelector('.swiper-wrapper') : null;
  var bacGalleryMainSlides = crateRoot
    ? Array.from(crateRoot.querySelectorAll('[data-gallery-main-slide]'))
    : [];
  var bacGalleryThumbSlides = bacThumbGalleryWrapper
    ? Array.from(bacThumbGalleryWrapper.querySelectorAll('.swiper-slide'))
    : [];
  var bacVisibleGallerySignature = null;
  var bacActiveGalleryKey = null;
  var bacGallerySlideChangeBound = false;
  var cfg = {
    basePrice: 0,
    totalLabel: '',
    totalSuffix: '',
    addedLabel: '',
    addLabel: '',
    removeLabel: '',
    atcTemplate: '',
    atcLoading: ''
  };
  if (crateRoot && crateRoot.dataset) {
    var bp = parseFloat(crateRoot.dataset.addonBasePrice, 10);
    cfg.basePrice = isNaN(bp) ? 0 : bp;
    if (crateRoot.dataset.addonTotalLabel) cfg.totalLabel = crateRoot.dataset.addonTotalLabel;
    if (crateRoot.dataset.addonTotalSuffix) cfg.totalSuffix = crateRoot.dataset.addonTotalSuffix;
    if (crateRoot.dataset.addonAddedLabel) cfg.addedLabel = crateRoot.dataset.addonAddedLabel;
    if (crateRoot.dataset.addonAddLabel) cfg.addLabel = crateRoot.dataset.addonAddLabel;
    if (crateRoot.dataset.addonRemoveLabel) cfg.removeLabel = crateRoot.dataset.addonRemoveLabel;
    if (crateRoot.dataset.atcLabelTemplate) cfg.atcTemplate = crateRoot.dataset.atcLabelTemplate;
    if (crateRoot.dataset.atcLoadingLabel) cfg.atcLoading = crateRoot.dataset.atcLoadingLabel;
  }

  var defaultCrate = (crateRoot && crateRoot.dataset.bacDefaultCrateType)
    ? crateRoot.dataset.bacDefaultCrateType.trim()
    : '';
  var checkedCrateRadio = document.querySelector('[data-bac-crate-radio]:checked');
  if (!defaultCrate && checkedCrateRadio) {
    defaultCrate = (checkedCrateRadio.getAttribute('data-crate-type') || '').trim();
  }
  window.buildACrateFlow.selectedCrateType = defaultCrate;

  const planTypeRadios = document.querySelectorAll('[data-bac-purchase-mode-input]');

  function getPurchaseMode() {
    var checked = dom.getCheckedPurchaseModeInput();
    if (!checked) return 'subscribe';
    return checked.getAttribute('data-bac-purchase-mode') || 'subscribe';
  }

  function resolveProductTypeFromSpType(spType) {
    var key = String(spType || '').trim();
    return key || 'core';
  }

  function syncFlowProductTypeFromPlanCard() {
    var flow = window.buildACrateFlow;
    var card = flow.getActivePlanCard
      ? flow.getActivePlanCard()
      : dom.getSelectedPlanCard();
    if (!card) return;
    var spType = card.getAttribute('data-sp-type') || getActiveSpType() || '';
    var productType =
      spType ||
      card.getAttribute('data-bac-product-type') ||
      resolveProductTypeFromSpType(spType);
    flow.productType = productType || 'core';
  }

  window.buildACrateFlow.resolveProductTypeFromSpType = resolveProductTypeFromSpType;
  window.buildACrateFlow.syncFlowProductTypeFromPlanCard = syncFlowProductTypeFromPlanCard;

  function readPlanCardSelection(card) {
    if (!card) return null;
    var mode = getPurchaseMode();
    if (!isPlanCardConfiguredForPurchaseMode(card, mode)) return null;
    var body = getPlanProductBodyForMode(card, mode);
    var d = body ? body.dataset : {};
    var spType = card.getAttribute('data-sp-type') || '';
    var productType = spType || card.getAttribute('data-bac-product-type') || resolveProductTypeFromSpType(spType);
    var shipFrequency = card.getAttribute('data-sp-frequency') || '';
    if (!body) {
      return {
        purchaseMode: mode,
        spType: spType,
        productType: productType,
        subscriptionProductId: '',
        subscriptionHandle: '',
        payFrequency: card.getAttribute('data-pay-frequency') || '',
        shipFrequency: shipFrequency,
        perCrateCents: '',
        enableGifting: card.getAttribute('data-enable-gifting') === 'true',
        giftVariantId: ''
      };
    }
    return {
      purchaseMode: mode,
      spType: spType,
      productType: productType,
      mainProductId: d.bacPlanProductId || '',
      subscriptionProductId: d.bacPlanProductId || '',
      subscriptionHandle: d.bacPlanProductHandle || '',
      payFrequency: d.bacPlanPayFrequency || card.getAttribute('data-pay-frequency') || '',
      shipFrequency: d.bacPlanShipFrequency || shipFrequency,
      perCrateCents: d.bacPlanPerCrateCents || '',
      enableGifting: card.getAttribute('data-enable-gifting') === 'true',
      giftVariantId: d.bacPlanGiftVariantId || ''
    };
  }

  function applyPurchaseModeToPlanCards(mode) {
    document.querySelectorAll('[data-plan-card]').forEach(function(card) {
      var views = Array.from(card.querySelectorAll('[data-bac-plan-view]'));
      if (!views.length) return;

      var preferred = views.find(function(v) {
        return v.getAttribute('data-bac-plan-view') === mode &&
          v.querySelector('[data-bac-plan-body][data-bac-plan-product-id]');
      });
      var fallback = views.find(function(v) {
        return v.querySelector('[data-bac-plan-body][data-bac-plan-product-id]');
      });
      var toShow = preferred || fallback;

      views.forEach(function(view) {
        if (toShow) {
          view.toggleAttribute('hidden', view !== toShow);
        } else {
          view.setAttribute('hidden', '');
        }
      });
    });
    window.buildACrateFlow.purchaseMode = mode;
    filterPlanCards({ keepSelection: true, trigger: 'purchase-mode', triggerDetail: { mode: mode } });
  }

  /**
   * Plan visibility uses recommended_item item_type (shirt / pro), never product handles.
   * Maps to plan_card block setting sp_type via data-bac-sp-type-map on the section.
   */
  function getAddonItemTypeOrder() {
    var raw = crateRoot ? crateRoot.getAttribute('data-bac-addon-item-types') : '';
    if (!raw) raw = 'shirt,pro';
    return raw
      .toLowerCase()
      .split(',')
      .map(function(s) { return s.trim(); })
      .filter(Boolean);
  }

  function getSpTypeMap() {
    var defaults = {
      '': 'core',
      shirt: 'core-shirt',
      pro: 'core-pro',
      'shirt+pro': 'core-shirt-pro'
    };
    var raw = crateRoot ? crateRoot.getAttribute('data-bac-sp-type-map') : '';
    if (!raw) return defaults;
    try {
      var parsed = JSON.parse(raw);
      return Object.assign({}, defaults, parsed);
    } catch (err) {
      return defaults;
    }
  }

  function getAddonSelectionKey(addedItemTypes) {
    var order = getAddonItemTypeOrder();
    var known = order.filter(function(type) {
      return addedItemTypes.indexOf(type) >= 0;
    });
    return known.join('+');
  }

  function resolveSpTypeFromAddonTypes(addedItemTypes) {
    var map = getSpTypeMap();
    var selectionKey = getAddonSelectionKey(addedItemTypes || []);
    if (map[selectionKey]) return map[selectionKey];
    if (!selectionKey) return map[''] || map.core || 'core';
    return 'core-' + selectionKey.replace(/\+/g, '-');
  }

  function getAddedItemTypes() {
    var addedTypes = [];
    dom.queryAddons({}).forEach(function(el) {
      if (el.getAttribute('data-added') !== 'true') return;
      var itemType = (el.getAttribute('data-item-type') || '').toLowerCase().trim();
      if (!itemType) return;
      if (getAddonItemTypeOrder().indexOf(itemType) < 0) return;
      if (addedTypes.indexOf(itemType) < 0) addedTypes.push(itemType);
    });
    return addedTypes;
  }

  function getActiveSpType() {
    return resolveSpTypeFromAddonTypes(getAddedItemTypes());
  }

  window.buildACrateFlow.getActiveSpType = getActiveSpType;
  window.buildACrateFlow.getAddedItemTypes = getAddedItemTypes;
  window.buildACrateFlow.resolveSpTypeFromAddonTypes = resolveSpTypeFromAddonTypes;

  function getPlanCardFilterMeta(card) {
    if (!card) return null;
    return {
      spType: card.getAttribute('data-sp-type') || '',
      shipFrequency: card.getAttribute('data-sp-frequency') || '',
      unconfigured: card.hasAttribute('data-plan-card-unconfigured')
    };
  }

  function getSelectedShipFrequency() {
    var shipFrequency = normalizeShipFrequency(window.buildACrateFlow.shipFrequency);
    if (!Number.isFinite(shipFrequency)) {
      var checkedFreq = document.querySelector('[data-bac-ship-frequency-option]:checked');
      if (checkedFreq) {
        shipFrequency = normalizeShipFrequency(checkedFreq.value);
        if (Number.isFinite(shipFrequency)) {
          window.buildACrateFlow.shipFrequency = String(shipFrequency);
        }
      }
    }
    return shipFrequency;
  }

  function updatePlanCardsEmptyState(requestedSpType, shipFrequency) {
    var emptyEl = document.querySelector('[data-bac-plan-cards-empty]');
    if (!emptyEl) return;

    var visibleCount = 0;
    getPlanCards().forEach(function(card) {
      if (!dom.isHidden(card)) visibleCount++;
    });

    var purchaseMode = getPurchaseMode();
    var configuredVisible = 0;
    getPlanCards().forEach(function(card) {
      if (!dom.isHidden(card) && isPlanCardConfiguredForPurchaseMode(card, purchaseMode)) {
        configuredVisible++;
      }
    });
    var showEmpty = configuredVisible === 0 && Number.isFinite(shipFrequency);
    dom.setHidden(emptyEl, !showEmpty);
    if (showEmpty) {
      emptyEl.removeAttribute('hidden');
    } else {
      emptyEl.setAttribute('hidden', '');
    }

    var detailEl = emptyEl.querySelector('[data-bac-plan-cards-empty-detail]');
    if (detailEl) {
      if (showEmpty && requestedSpType) {
        detailEl.textContent = ' Subscription type: ' + requestedSpType +
          '. Delivery frequency: ' + shipFrequency + ' month(s) between crates. ' +
          'Add a Plan card block with matching Subscription Type and Delivery frequency, and assign products.';
        dom.setHidden(detailEl, false);
      } else {
        detailEl.textContent = '';
        dom.setHidden(detailEl, true);
      }
    }

    if (window.buildACrateFlow) {
      window.buildACrateFlow.requestedSpType = requestedSpType;
      window.buildACrateFlow.visiblePlanCardCount = visibleCount;
    }
  }

  function filterPlanCards(options) {
    options = options || {};
    var preferredPayFrequency = null;
    if (options.keepPayFrequency) {
      var prevSelected = dom.getSelectedPlanCard();
      if (!prevSelected) {
        var prevChecked = document.querySelector('[data-bac-plan-card-input]:checked');
        prevSelected = prevChecked ? prevChecked.closest('[data-plan-card]') : null;
      }
      if (prevSelected) {
        preferredPayFrequency = prevSelected.getAttribute('data-pay-frequency');
      }
    }

    var requestedSpType = getActiveSpType();
    var shipFrequency = getSelectedShipFrequency();
    var planCards = getPlanCards();

    var purchaseMode = getPurchaseMode();
    planCards.forEach(function(card) {
      var show = cardMatchesPlanFilter(card, requestedSpType, shipFrequency);
      dom.setHidden(card, !show);
      if (!show) {
        dom.setPlanSelected(card, false);
        return;
      }

      var configuredForMode = isPlanCardConfiguredForPurchaseMode(card, purchaseMode);
      var planInput = card.querySelector('[data-bac-plan-card-input]');
      if (!configuredForMode) {
        dom.setPlanSelected(card, false);
        if (planInput) {
          planInput.checked = false;
          planInput.disabled = true;
        }
      } else if (planInput) {
        planInput.disabled = false;
      }
    });

    updatePlanCardsEmptyState(requestedSpType, shipFrequency);

    if (!options.keepSelection) {
      ensureSelectedPlanCard(preferredPayFrequency);
    } else {
      var stillSelected = dom.getSelectedPlanCard();
      if (!stillSelected) {
        ensureSelectedPlanCard(preferredPayFrequency);
      } else {
        window.buildACrateFlow.selectedPlanCard = readPlanCardSelection(stillSelected);
      }
    }

    collectPlanCardsState(requestedSpType, shipFrequency);
    logPlanFilterState(options.trigger || 'filterPlanCards', options.triggerDetail);
    syncInsideCrateAccordionFromSelections();
    updatePlanGiftDisplay();
    updateTotalPrice();
    syncFlowProductTypeFromPlanCard();
    refreshAtcSubmitState();
    showPlanCardsSection();
    schedulePaymentOptionsSwiperRefresh();
  }

  function showPlanCardsSection() {
    var section = document.querySelector('[data-bac-plan-cards-section]');
    if (!section) return;
    section.setAttribute('data-bac-plan-section-ready', 'true');
    section.removeAttribute('data-bac-plan-section-pending');
  }

  function refreshPaymentOptionsSwiper() {
    var el = document.querySelector('[data-payment-options-slider]');
    if (!el) return;
    var inst = el.swiper;
    if (!inst || typeof inst.update !== 'function') return;
    inst.update();
    if (typeof inst.updateSize === 'function') {
      inst.updateSize();
    }
    if (inst.scrollbar && typeof inst.scrollbar.updateSize === 'function') {
      inst.scrollbar.updateSize();
    }
  }

  function schedulePaymentOptionsSwiperRefresh() {
    window.requestAnimationFrame(function() {
      window.requestAnimationFrame(refreshPaymentOptionsSwiper);
      window.setTimeout(refreshPaymentOptionsSwiper, 120);
    });
  }

  function parseGiftVariantId(raw) {
    if (raw == null || raw === '') return null;
    var giftVariantId = parseInt(raw, 10);
    return Number.isFinite(giftVariantId) ? giftVariantId : null;
  }

  function resolveGiftVariantIdForCard(card) {
    if (window.buildACrateFlow.resolveGiftVariantIdForCard) {
      return window.buildACrateFlow.resolveGiftVariantIdForCard(card);
    }
    if (!card || card.getAttribute('data-enable-gifting') !== 'true') return null;
    return parseGiftVariantId(card.getAttribute('data-bac-gift-variant-id'));
  }

  function syncGiftBanner(card) {
    var gifts = document.querySelectorAll('[data-bac-plan-gifts] [data-bac-plan-gift-banner]');
    var blockId = card ? (card.getAttribute('data-bac-plan-block-id') || '') : '';
    var showGift = !!(
      card &&
      card.getAttribute('data-enable-gifting') === 'true' &&
      blockId
    );

    for (var i = 0; i < gifts.length; i++) {
      var gift = gifts[i];
      var giftBlockId = gift.getAttribute('data-bac-plan-block-id') || '';
      var shouldShow = showGift && giftBlockId === blockId;
      dom.setHidden(gift, !shouldShow);
    }

    window.buildACrateFlow.giftVariantId = showGift ? resolveGiftVariantIdForCard(card) : null;
  }

  function updatePlanGiftDisplay() {
    var selectedCard = dom.getSelectedPlanCard();
    if (!selectedCard || selectedCard.getAttribute('data-enable-gifting') !== 'true') {
      syncGiftBanner(null);
      return;
    }

    syncGiftBanner(selectedCard);
  }

  var insideCrateAccordion = document.querySelector('[data-inside-crate-accordion]');
  var insideCrateAccordionKey = null;

  function getBacSelectedCrateSlot() {
    var checkedCrate = document.querySelector('[data-bac-crate-radio]:checked');
    return checkedCrate ? (checkedCrate.getAttribute('data-crate-slot') || 'crate_1') : 'crate_1';
  }

  function refreshInsideCrateSwiperLayout() {
    if (!insideCrateAccordion) return;
    var swiperEl = insideCrateAccordion.querySelector('[data-bac-inside-crate-swiper]');
    var inst = swiperEl && swiperEl.swiper;
    if (!inst || typeof inst.update !== 'function') return;
    inst.update();
    if (typeof inst.updateSize === 'function') inst.updateSize();
    if (typeof inst.slideTo === 'function') inst.slideTo(0, 0, false);
  }

  function scheduleInsideCrateSwiperLayoutRefresh() {
    window.requestAnimationFrame(function() {
      window.requestAnimationFrame(refreshInsideCrateSwiperLayout);
      window.setTimeout(refreshInsideCrateSwiperLayout, 120);
    });
  }

  function applyInsideCrateAccordionEmptyState() {
    if (!insideCrateAccordion) return;
    var slides = insideCrateAccordion.querySelectorAll('[data-inside-crate-slide]');
    var visibleCount = 0;
    slides.forEach(function(slide) {
      if (!dom.isHidden(slide)) visibleCount++;
    });
    dom.setInsideCrateEmpty(insideCrateAccordion, visibleCount === 0);
  }

  function syncInsideCrateAccordionFromSelections() {
    if (!insideCrateAccordion) return;

    var slides = insideCrateAccordion.querySelectorAll('[data-inside-crate-slide]');
    if (!slides.length) {
      insideCrateAccordionKey = null;
      dom.setInsideCrateEmpty(insideCrateAccordion, true);
      return;
    }

    var spType = getActiveSpType();
    var crateSlot = getBacSelectedCrateSlot();
    var visibilityKey = (spType || '') + '::' + (crateSlot || '');

    if (insideCrateAccordionKey !== visibilityKey) {
      insideCrateAccordionKey = visibilityKey;

      slides.forEach(function(slide) {
        var slideSpType = slide.getAttribute('data-sp-sub-type') || '';
        var slideCrate = slide.getAttribute('data-sp-crate-slot') || '';
        var planMatches = !slideSpType || !spType || slideSpType === spType;
        var crateMatches = !!(crateSlot && slideCrate === crateSlot);
        dom.setHidden(slide, !(planMatches && crateMatches));
      });

      scheduleInsideCrateSwiperLayoutRefresh();
    }

    applyInsideCrateAccordionEmptyState();
  }

  function bindInsideCrateAccordionRefresh() {
    if (!insideCrateAccordion) return;
    var content = insideCrateAccordion.querySelector('[data-bac-accordion-content]');
    if (!content) return;

    var observer = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class' && dom.isAccordionContentOpen(content)) {
          scheduleInsideCrateSwiperLayoutRefresh();
          break;
        }
      }
    });
    observer.observe(content, { attributes: true, attributeFilter: ['class'] });

    if (dom.isAccordionContentOpen(content)) {
      scheduleInsideCrateSwiperLayoutRefresh();
    }
  }

  function ensureSelectedPlanCard(preferredPayFrequency) {
    var planCards = getPlanCards();
    var selected = null;
    var purchaseMode = getPurchaseMode();
    planCards.forEach(function(card) {
      if (dom.isHidden(card) || !isPlanCardConfiguredForPurchaseMode(card, purchaseMode)) return;
      if (dom.isPlanSelected(card)) {
        selected = card;
      }
    });

    if (selected) {
      var selectedInput = selected.querySelector('[data-bac-plan-card-input]');
      if (selectedInput) selectedInput.checked = true;
      window.buildACrateFlow.selectedPlanCard = readPlanCardSelection(selected);
      return;
    }

    var firstVisible = null;
    var preferredMatch = null;
    var payFreqStr = preferredPayFrequency != null ? String(preferredPayFrequency).trim() : '';
    planCards.forEach(function(card) {
      if (dom.isHidden(card) || !isPlanCardConfiguredForPurchaseMode(card, purchaseMode)) return;
      if (!firstVisible) firstVisible = card;
      if (payFreqStr && card.getAttribute('data-pay-frequency') === payFreqStr && !preferredMatch) {
        preferredMatch = card;
      }
    });

    var pick = preferredMatch || firstVisible;

    planCards.forEach(function(c) {
      dom.setPlanSelected(c, false);
      var input = c.querySelector('[data-bac-plan-card-input]');
      if (input) input.checked = false;
    });
    if (pick) {
      dom.setPlanSelected(pick, true);
      var pickInput = pick.querySelector('[data-bac-plan-card-input]');
      if (pickInput) pickInput.checked = true;
      window.buildACrateFlow.selectedPlanCard = readPlanCardSelection(pick);
    } else {
      window.buildACrateFlow.selectedPlanCard = null;
    }
  }

  const checkedPlanOnLoad = dom.getCheckedPurchaseModeInput();
  if (checkedPlanOnLoad) {
    window.buildACrateFlow.purchaseMode = getPurchaseMode();
  } else {
    window.buildACrateFlow.purchaseMode = 'subscribe';
  }

  // Get DOM elements
  const crateRadios = document.querySelectorAll('[data-bac-crate-radio]');

  function getMatchingBacGalleryIndices(crateType) {
    var matched = [];
    var placeholderIndex = -1;

    for (var i = 0; i < bacGalleryMainSlides.length; i++) {
      var slide = bacGalleryMainSlides[i];
      if (!slide) continue;
      if (slide.hasAttribute('data-bac-gallery-default')) {
        placeholderIndex = i;
        continue;
      }
      if (slide.getAttribute('data-crate-type') === crateType) {
        matched.push(i);
      }
    }

    if (matched.length) {
      return matched;
    }
    if (placeholderIndex >= 0) {
      return [placeholderIndex];
    }
    return [];
  }

  function renderMatchingBacGallerySlides(indices) {
    if (!bacMainGalleryWrapper) return;

    var normalizedIndices =
      Array.isArray(indices) && indices.length
        ? indices
        : bacGalleryMainSlides.map(function(_, index) { return index; });
    var signature = normalizedIndices.join(',');

    if (bacVisibleGallerySignature === signature) {
      return;
    }
    bacVisibleGallerySignature = signature;

    while (bacMainGalleryWrapper.firstChild) {
      bacMainGalleryWrapper.removeChild(bacMainGalleryWrapper.firstChild);
    }

    var mainFragment = document.createDocumentFragment();
    for (var i = 0; i < normalizedIndices.length; i++) {
      var mainSlide = bacGalleryMainSlides[normalizedIndices[i]];
      if (mainSlide) {
        mainFragment.appendChild(mainSlide);
      }
    }
    bacMainGalleryWrapper.appendChild(mainFragment);

    if (bacThumbGalleryWrapper) {
      while (bacThumbGalleryWrapper.firstChild) {
        bacThumbGalleryWrapper.removeChild(bacThumbGalleryWrapper.firstChild);
      }

      var thumbFragment = document.createDocumentFragment();
      for (var j = 0; j < normalizedIndices.length; j++) {
        var mainRef = bacGalleryMainSlides[normalizedIndices[j]];
        if (!mainRef || mainRef.hasAttribute('data-bac-gallery-default')) {
          continue;
        }
        var mediaId = mainRef.getAttribute('data-mediaID');
        for (var k = 0; k < bacGalleryThumbSlides.length; k++) {
          var thumbSlide = bacGalleryThumbSlides[k];
          var thumbMedia = thumbSlide.querySelector('[data-gallery-thumb-slide]');
          if (
            thumbSlide.getAttribute('data-crate-type') === mainRef.getAttribute('data-crate-type') &&
            thumbMedia &&
            thumbMedia.getAttribute('data-mediaID') === mediaId
          ) {
            thumbFragment.appendChild(thumbSlide);
            break;
          }
        }
      }
      bacThumbGalleryWrapper.appendChild(thumbFragment);
    }

    var mainSwiper = bacMainGallery && bacMainGallery.swiper ? bacMainGallery.swiper : null;
    if (mainSwiper && typeof mainSwiper.update === 'function') {
      mainSwiper.update();
      if (typeof mainSwiper.updateSize === 'function') {
        mainSwiper.updateSize();
      }
      mainSwiper.slideTo(0, 0, false);
    }

    var thumbSwiper = bacThumbGallery && bacThumbGallery.swiper ? bacThumbGallery.swiper : null;
    if (thumbSwiper && typeof thumbSwiper.update === 'function') {
      thumbSwiper.update();
      if (typeof thumbSwiper.updateSize === 'function') {
        thumbSwiper.updateSize();
      }
      thumbSwiper.slideTo(0, 0, false);
    }
  }

  function activateBacGalleryForCrate(crateType, attempt) {
    if (typeof attempt !== 'number') attempt = 0;
    var mainSwiper = bacMainGallery && bacMainGallery.swiper ? bacMainGallery.swiper : null;
    var thumbSwiper = bacThumbGallery && bacThumbGallery.swiper ? bacThumbGallery.swiper : null;

    if (!mainSwiper) {
      if (attempt < 10) {
        window.setTimeout(function() {
          activateBacGalleryForCrate(crateType, attempt + 1);
        }, 120);
      }
      return;
    }

    if (!bacMainGalleryWrapper || !bacMainGalleryWrapper.querySelector('.swiper-slide')) {
      return;
    }

    if (thumbSwiper) {
      thumbSwiper.slideTo(0, 300, false);
    }
    mainSwiper.slideTo(0, 300, false);

    if (!bacGallerySlideChangeBound) {
      bacGallerySlideChangeBound = true;
      mainSwiper.on('slideChange', syncBacStickyImage);
    }
    syncBacStickyImage();
  }

  function showImagesForCrateType(crateType) {
    if (!crateType || !bacGalleryMainSlides.length) {
      syncBacStickyImage();
      return;
    }

    var matchingIndices = getMatchingBacGalleryIndices(crateType);
    var key = crateType + '::' + matchingIndices.join(',');

    if (bacActiveGalleryKey !== key) {
      bacActiveGalleryKey = key;
      renderMatchingBacGallerySlides(matchingIndices);
      activateBacGalleryForCrate(crateType);
    } else {
      syncBacStickyImage();
    }
  }

  // Crate type selection (radio pills — same as subscription-product)
  crateRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (!this.checked) return;

      var crateType = this.getAttribute('data-crate-type');
      window.buildACrateFlow.selectedCrateType = crateType;
      showImagesForCrateType(crateType);
      syncInsideCrateAccordionFromSelections();
      refreshAtcSubmitState();
    });
  });

  // Subscribe vs Buy Once — switches plan card product (auto renew vs one-time)
  planTypeRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (!this.checked) return;
      window.buildACrateFlow.purchaseMode = getPurchaseMode();
      applyPurchaseModeToPlanCards(getPurchaseMode());
      updatePlanGiftDisplay();
      refreshAtcSubmitState();
    });
  });

  // Delivery frequency handling
  const bacFreqLabel = document.querySelector('[data-bac-payment-frequency-label]');
  const bacFreqWrap = document.querySelector('[data-bac-frequency-options-wrap]');
  const bacScrollDelivery = document.querySelector('[data-bac-scroll-to-delivery]');
  const bacFreqSelect = document.querySelector('[data-bac-sub-ship-frequency]');
  const bacFreqRadios = document.querySelectorAll('[data-bac-ship-frequency-option]');

  function updateBacShipFrequencyUi() {
    const checkedRadio = Array.from(bacFreqRadios).find(function(r) { return r.checked; });
    if (!checkedRadio) return;

    const freq = checkedRadio.value;
    const freqNum = normalizeShipFrequency(freq);
    const title = checkedRadio.getAttribute('data-frequency-title') || freq;

    if (bacFreqSelect) bacFreqSelect.value = freq;
    if (bacFreqLabel) bacFreqLabel.textContent = title.trim();
    if (window.buildACrateFlow) {
      window.buildACrateFlow.shipFrequency = Number.isFinite(freqNum) ? String(freqNum) : freq;
      window.buildACrateFlow.deliveryFrequencyLabel = title;
    }

    filterPlanCards({ keepSelection: false, trigger: 'ship-frequency-change' });
  }

  bacFreqRadios.forEach(function(radio) {
    radio.addEventListener('change', function() {
      if (radio.checked) updateBacShipFrequencyUi();
    });
  });

  if (bacFreqSelect && bacFreqRadios.length) {
    bacFreqSelect.addEventListener('change', function() {
      const v = bacFreqSelect.value;
      bacFreqRadios.forEach(function(r) { r.checked = r.value === v; });
      updateBacShipFrequencyUi();
    });
  }

  if (bacScrollDelivery && bacFreqWrap) {
    bacScrollDelivery.addEventListener('click', function(ev) {
      ev.preventDefault();
      const isOpen = (function(){ var open = !dom.isFreqOptionsOpen(bacFreqWrap); dom.setFreqOptionsOpen(bacFreqWrap, open); return open; })();
      bacScrollDelivery.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) {
        bacFreqWrap.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    });
  }

  // Plan cards — filtered by delivery frequency + sp_type (same as subscription-product)
  getPlanCards().forEach(function(card) {
    var planRadio = card.querySelector('[data-bac-plan-card-input]');
    if (planRadio) {
      planRadio.addEventListener('change', function() {
        if (!this.checked || dom.isHidden(card)) return;
        getPlanCards().forEach(function(c) {
          dom.setPlanSelected(c, false);
          var inp = c.querySelector('[data-bac-plan-card-input]');
          if (inp) inp.checked = false;
        });
        dom.setPlanSelected(card, true);
        this.checked = true;
        window.buildACrateFlow.selectedPlanCard = readPlanCardSelection(card);
        updatePlanGiftDisplay();
        updateTotalPrice();
        syncFlowProductTypeFromPlanCard();
        refreshAtcSubmitState();
      });
    }

    card.addEventListener('click', function() {
      if (dom.isHidden(this)) return;
      getPlanCards().forEach(function(c) {
        dom.setPlanSelected(c, false);
        var input = c.querySelector('[data-bac-plan-card-input]');
        if (input) input.checked = false;
      });
      dom.setPlanSelected(this, true);
      var input = this.querySelector('[data-bac-plan-card-input]');
      if (input) input.checked = true;
      if (!window.buildACrateFlow) return;
      window.buildACrateFlow.selectedPlanCard = readPlanCardSelection(this);
      updatePlanGiftDisplay();
      updateTotalPrice();
      syncFlowProductTypeFromPlanCard();
      refreshAtcSubmitState();
    });
  });

  function parseMoneyText(text) {
    if (!text) return 0;
    var cleaned = String(text).replace(/[^0-9.]/g, '');
    var amount = parseFloat(cleaned);
    return isNaN(amount) ? 0 : amount;
  }

  function getDiscountApi() {
    return typeof BuildACrateDiscounts !== 'undefined' ? BuildACrateDiscounts : null;
  }

  function isBundlePlanBody(body) {
    if (!body) return false;
    var payFreq = parseInt(body.getAttribute('data-bac-plan-pay-frequency'), 10);
    var shipFreq = parseInt(body.getAttribute('data-bac-plan-ship-frequency'), 10);
    return Number.isFinite(payFreq) && Number.isFinite(shipFreq) && payFreq !== shipFreq;
  }

  function calculatePlanSubtotalCents(body) {
    var api = getDiscountApi();
    if (api) return api.calculatePlanSubtotalCents(body);
    var baked = parseInt(body && body.getAttribute('data-bac-plan-subtotal-cents'), 10);
    return Number.isFinite(baked) ? Math.max(0, baked) : 0;
  }

  function pricesDiffer(originalDollars, discountedDollars) {
    if (typeof BuildACrateDiscounts !== 'undefined' && BuildACrateDiscounts.pricesDifferInCents) {
      return BuildACrateDiscounts.pricesDifferInCents(
        Math.round(originalDollars * 100),
        Math.round(discountedDollars * 100)
      );
    }
    return Number.isFinite(originalDollars) &&
      Number.isFinite(discountedDollars) &&
      Math.round(originalDollars * 100) > Math.round(discountedDollars * 100);
  }

  function applyDualPriceDisplay(options) {
    var compareEl = options.compareEl;
    var currentEl = options.currentEl;
    var api = options.api;
    if (!compareEl || !currentEl || !api) return;

    var suffix = options.suffix || '';
    var original = options.originalDollars;
    var discounted = options.discountedDollars;
    var showCompare = pricesDiffer(original, discounted);

    if (showCompare) {
      compareEl.textContent = api.formatMoney(original) + suffix;
      currentEl.textContent = api.formatMoney(discounted) + suffix;
      dom.setPriceHidden(compareEl, false);
      dom.setPriceDiscounted(currentEl, true);
      return;
    }

    dom.setPriceHidden(compareEl, true);
    currentEl.textContent = api.formatMoney(original) + suffix;
    dom.setPriceDiscounted(currentEl, false);
  }

  function updatePlanCardPriceDisplay(body) {
    if (!body) return;
    var api = getDiscountApi();
    if (!api) return;

    var prices = api.getPriceDisplayState(body);
    var suffix = body.getAttribute('data-bac-per-crate-suffix') || '';
    var isBundle = isBundlePlanBody(body);
    var showPerCrateDiscount = !isBundle && prices.hasPerCrateDiscount;

    var perCrateEl = body.querySelector('[data-bac-plan-per-crate]');
    if (perCrateEl) {
      if (showPerCrateDiscount) {
        perCrateEl.innerHTML =
          '<s class="sp-price-old fw-normal">' +
          api.formatMoney(prices.originalPerCrateDollars) +
          '</s> <span class="sp-price-new fw-bold text-secondary">' +
          api.formatMoney(prices.discountedPerCrateDollars) +
          '</span>' +
          suffix;
      } else {
        perCrateEl.textContent = api.formatMoney(prices.originalPerCrateDollars) + suffix;
      }
    }

    var subtotalWrap = body.querySelector('[data-bac-plan-subtotal-wrap]');
    if (subtotalWrap) {
      applyDualPriceDisplay({
        compareEl: body.querySelector('[data-bac-plan-subtotal-compare]'),
        currentEl: body.querySelector('[data-bac-plan-subtotal-display]'),
        api: api,
        suffix: '',
        originalDollars: prices.originalSubtotalDollars,
        discountedDollars: prices.discountedSubtotalDollars
      });
    }

    var subtotalEl = body.querySelector('[data-bac-plan-subtotal]');
    if (subtotalEl) {
      subtotalEl.textContent = api.formatMoney(
        prices.hasSubtotalDiscount
          ? prices.discountedSubtotalDollars
          : prices.originalSubtotalDollars
      );
    }

    var flashBadge = body.querySelector('[data-bac-flash-discount-badge]');
    var activeDiscount = api.resolveActiveDateDiscount(body);
    if (flashBadge) {
      if (activeDiscount && prices.hasSubtotalDiscount) {
        flashBadge.textContent = api.formatActiveDiscountLabel(activeDiscount);
        dom.setHidden(flashBadge, false);
      } else {
        dom.setHidden(flashBadge, true);
      }
    }
  }

  function updateAllVisiblePlanCardPrices() {
    dom.queryVisiblePlanCards().forEach(function(card) {
      var mode = getPurchaseMode();
      var view = card.querySelector('[data-bac-plan-view="' + mode + '"]');
      if (!view) return;
      var body = view.querySelector('[data-bac-plan-body][data-bac-plan-product-id]');
      if (!body) return;
      updatePlanCardPriceDisplay(body);
    });
  }

  function getSelectedPlanPriceAmount() {
    var card = window.buildACrateFlow.getActivePlanCard
      ? window.buildACrateFlow.getActivePlanCard()
      : dom.getSelectedPlanCard();
    if (!card) return 0;

    var body = getPlanProductBodyForMode(card, getPurchaseMode());
    if (!body) return 0;

    var subtotalCents = calculatePlanSubtotalCents(body);
    if (subtotalCents > 0) {
      return subtotalCents / 100;
    }

    var subtotalEl = body.querySelector('[data-bac-plan-subtotal]');
    if (subtotalEl && subtotalEl.textContent.trim()) {
      return parseMoneyText(subtotalEl.textContent);
    }

    return 0;
  }

  function getSelectedPlanPerCrateAmount() {
    var card = window.buildACrateFlow.getActivePlanCard
      ? window.buildACrateFlow.getActivePlanCard()
      : dom.getSelectedPlanCard();
    if (!card) return 0;
    var body = getPlanProductBodyForMode(card, getPurchaseMode());
    if (!body) return 0;
    var api = getDiscountApi();
    if (!api) return 0;
    var subtotalCents = api.calculatePlanSubtotalCents(body);
    return api.calculatePerCrateCents(body, subtotalCents) / 100;
  }

  function updateHeroStartingPrice(prices, body) {
    var api = getDiscountApi();
    var heroCompare = document.querySelector('[data-bac-starting-price-compare]');
    var heroCurrent = document.querySelector('[data-bac-starting-price-amount]');
    if (!heroCurrent || !api || !prices) return;

    var isBundle = isBundlePlanBody(body);
    var showPerCrateDiscount = !isBundle && prices.hasPerCrateDiscount;

    if (heroCompare) {
      if (showPerCrateDiscount) {
        heroCompare.textContent = api.formatMoney(prices.originalPerCrateDollars);
        dom.setHidden(heroCompare, false);
      } else {
        dom.setHidden(heroCompare, true);
      }
    }
    heroCurrent.textContent = api.formatMoney(
      showPerCrateDiscount ? prices.discountedPerCrateDollars : prices.originalPerCrateDollars
    );
    dom.setPriceDiscounted(heroCurrent, showPerCrateDiscount);
  }

  function formatMoney(totalNum) {
    return '$' + totalNum.toFixed(2);
  }

  function applyAtcButtonLabel(priceState) {
    var btn = document.querySelector('[data-submit-build-a-crate]');
    if (!btn || !cfg.atcTemplate) return;
    var addText = btn.querySelector('[data-bac-atc-label]');
    if (!addText) return;

    var api = getDiscountApi();
    var formatPrice = api ? api.formatMoney.bind(api) : formatMoney;
    var discountedTotal = priceState.discountedTotal;
    var originalTotal = priceState.originalTotal;
    var hasDiscount = pricesDiffer(originalTotal, discountedTotal);
    var discountedStr = formatPrice(discountedTotal);
    var template = cfg.atcTemplate;

    if (hasDiscount && template.indexOf('{total}') >= 0) {
      var compareStr = formatPrice(originalTotal);
      var parts = template.split('{total}');
      addText.innerHTML =
        parts[0] +
        '<span class="bac-atc-price-pair d-inline-flex align-items-baseline flex-wrap" style="gap: 6px;">' +
        '<s class="sp-price-old fw-normal">' + compareStr + '</s>' +
        '<span class="sp-price-new fw-bold">' + discountedStr + '</span>' +
        '</span>' +
        parts.slice(1).join('{total}');
    } else {
      var label = template.split('{total}').join(discountedStr);
      addText.textContent = label;
    }

    addText.setAttribute(
      'data-default-cta',
      template.split('{total}').join(discountedStr)
    );
  }

  var STICKY_THUMB_IMAGE_WIDTH_1X = 160;
  var STICKY_THUMB_IMAGE_WIDTH_2X = 320;
  var bacStickySummaryOpen = false;
  var bacMainSubmitButton = document.querySelector('[data-submit-build-a-crate]');
  var bacSticky = {
    bar: document.querySelector('[data-sticky-subscription-bar]'),
    accordion: document.querySelector('[data-sticky-accordion]'),
    toggle: document.querySelector('[data-sticky-pdp-button]'),
    summaryToggle: document.querySelector('[data-sticky-summary-toggle]'),
    summary: document.querySelector('[data-sticky-summary]'),
    plan: document.querySelector('[data-sticky-plan]'),
    payment: document.querySelector('[data-sticky-payment]'),
    titleSeparator: document.querySelector('[data-sticky-title-sep]'),
    total: document.querySelector('[data-sticky-total]'),
    size: document.querySelector('[data-sticky-size]'),
    crate: document.querySelector('[data-sticky-crate]'),
    delivery: document.querySelector('[data-sticky-delivery]'),
    charge: document.querySelector('[data-sticky-charge]'),
    priceCurrent: document.querySelector('[data-sticky-price-current]'),
    priceCompare: document.querySelector('[data-sticky-price-compare]'),
    priceBadge: document.querySelector('[data-sticky-price-badge]'),
    desktopCompare: document.querySelector('[data-sticky-desktop-compare]'),
    desktopBadge: document.querySelector('[data-sticky-desktop-badge]'),
    buttonDivider: document.querySelector('[data-sticky-button-divider]'),
    buttonTotal: document.querySelector('[data-sticky-button-total]'),
    buttonCompare: document.querySelector('[data-sticky-button-compare]'),
    image: document.querySelector('[data-sticky-image]'),
    button: document.querySelector('[data-sticky-submit-build-a-crate]')
  };

  function getShopifyImageWithWidth(src, width) {
    if (!src || !Number.isFinite(width) || width <= 0) return '';
    try {
      var parsed = new URL(src, window.location.origin);
      var host = parsed.hostname || '';
      var isShopifyCdn =
        /(^|\.)cdn\.shopify\.com$/i.test(host) || parsed.pathname.indexOf('/cdn/shop/files/') >= 0;
      if (!isShopifyCdn) return '';
      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (err) {
      return '';
    }
  }

  function getEveryMonthsLabel(frequency) {
    var count = parseInt(frequency, 10);
    if (!Number.isFinite(count) || count <= 0) return '-';
    return 'Every ' + count + (count === 1 ? ' Month' : ' Months');
  }

  function normalizeStickyBadgeText(value) {
    var text = String(value || '').replace(/\s+/g, ' ').trim();
    if (!text) return '';
    var saveMatch = text.match(/^save\s+(.+)$/i);
    if (saveMatch && saveMatch[1]) {
      var amount = saveMatch[1].trim().toUpperCase();
      return amount.indexOf('OFF') >= 0 ? amount : amount + ' OFF';
    }
    var flashSaleMatch = text.match(/^flash sale\s*-\s*(.+)$/i);
    if (flashSaleMatch && flashSaleMatch[1]) {
      return flashSaleMatch[1].trim().toUpperCase();
    }
    return text.toUpperCase();
  }

  function getBacStickyPlanCardEl() {
    return window.buildACrateFlow.getActivePlanCard
      ? window.buildACrateFlow.getActivePlanCard()
      : dom.getSelectedPlanCard();
  }

  function getBacStickyPlanBody(card) {
    return card ? getPlanProductBodyForMode(card, getPurchaseMode()) : null;
  }

  function getBacStickyPaymentLabel() {
    var card = getBacStickyPlanCardEl();
    var body = getBacStickyPlanBody(card);
    var title = body ? body.querySelector('[data-bac-plan-title]') : null;
    return title ? title.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  function getBacStickyDeliveryText() {
    var freqRadio = document.querySelector('[data-bac-ship-frequency-option]:checked');
    if (freqRadio) {
      var title = freqRadio.getAttribute('data-frequency-title');
      if (title) return title.trim();
      var label = document.querySelector('label[for="' + freqRadio.id + '"]');
      if (label) return label.textContent.replace(/\s+/g, ' ').trim();
      return getEveryMonthsLabel(freqRadio.value);
    }
    var freqSelect = document.querySelector('[data-bac-sub-ship-frequency]');
    if (freqSelect && freqSelect.selectedOptions.length) {
      var opt = freqSelect.selectedOptions[0];
      var optTitle = opt.getAttribute('data-frequency-title');
      if (optTitle) return optTitle.trim();
      return getEveryMonthsLabel(opt.value);
    }
    return '-';
  }

  function getBacStickyChargeText() {
    var card = getBacStickyPlanCardEl();
    if (!card) return '-';
    return getEveryMonthsLabel(card.getAttribute('data-pay-frequency'));
  }

  function getBacStickyCrateText() {
    var radio = document.querySelector('[data-bac-crate-radio]:checked');
    if (!radio) return '-';
    var label = document.querySelector('label[for="' + radio.id + '"]');
    return label ? label.textContent.replace(/\s+/g, ' ').trim() : '-';
  }

  function getBacStickySizeText() {
    var shirt = dom.queryAddon('shirt', true);
    if (!shirt) return '-';
    var sel = shirt.querySelector('[data-item-size]');
    if (sel && sel.options.length) {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.textContent) return opt.textContent.trim();
    }
    return shirt.dataset.selectedSize || '-';
  }

  function getBacStickyPricing() {
    var card = getBacStickyPlanCardEl();
    var body = getBacStickyPlanBody(card);
    if (!body) return { current: '-', compare: '', badge: '' };

    var currentEl = body.querySelector('[data-bac-plan-subtotal-display]');
    var compareEl = body.querySelector('[data-bac-plan-subtotal-compare]');
    var perCrateEl = body.querySelector('[data-bac-plan-per-crate]');
    var discountBadgeEl = body.querySelector('[data-bac-flash-discount-badge]');
    var saveBadgeEl = body.querySelector('[data-bac-save-badge]');
    var current = currentEl
      ? currentEl.textContent.replace(/\s+/g, ' ').trim()
      : perCrateEl
        ? perCrateEl.textContent.replace(/\s+/g, ' ').trim()
        : '-';
    var compare = compareEl && !dom.isPriceHidden(compareEl)
      ? compareEl.textContent.replace(/\s+/g, ' ').trim()
      : '';
    var badge = '';

    if (discountBadgeEl && !dom.isPriceHidden(discountBadgeEl)) {
      badge = normalizeStickyBadgeText(discountBadgeEl.textContent);
    } else if (saveBadgeEl && !dom.isPriceHidden(saveBadgeEl)) {
      badge = normalizeStickyBadgeText(saveBadgeEl.textContent);
    }

    return { current: current, compare: compare, badge: badge };
  }

  function setBacStickySummaryOpen(isOpen) {
    bacStickySummaryOpen = !!isOpen;
    if (bacSticky.bar) {
      bacSticky.bar.classList.toggle('is-summary-open', bacStickySummaryOpen);
      bacSticky.bar.toggleAttribute('data-summary-open', bacStickySummaryOpen);
    }
    if (bacSticky.accordion) {
      bacSticky.accordion.classList.toggle('open', bacStickySummaryOpen);
      bacSticky.accordion.toggleAttribute('data-open', bacStickySummaryOpen);
    }
    if (bacSticky.summary) {
      bacSticky.summary.hidden = !bacStickySummaryOpen;
    }
    if (bacSticky.summaryToggle) {
      bacSticky.summaryToggle.textContent = bacStickySummaryOpen ? 'Hide Summary' : 'View Summary';
      bacSticky.summaryToggle.setAttribute('aria-expanded', String(bacStickySummaryOpen));
    }
    if (bacSticky.toggle) {
      bacSticky.toggle.setAttribute('aria-expanded', String(bacStickySummaryOpen));
      bacSticky.toggle.setAttribute(
        'aria-label',
        bacStickySummaryOpen ? 'Hide product summary' : 'Show product summary'
      );
    }
  }

  function syncBacStickyImage() {
    if (!bacSticky.image) return;

    var visibleSlide =
      (crateRoot && crateRoot.querySelector('.bac-product-carousel .swiper-slide-active')) ||
      (crateRoot && crateRoot.querySelector('[data-bac-gallery-default]'));

    var image = visibleSlide ? visibleSlide.querySelector('img') : null;
    if (!image) return;

    var sourceSrc = image.currentSrc || image.getAttribute('src');
    if (!sourceSrc) return;

    var capped1x = getShopifyImageWithWidth(sourceSrc, STICKY_THUMB_IMAGE_WIDTH_1X);
    var capped2x = getShopifyImageWithWidth(sourceSrc, STICKY_THUMB_IMAGE_WIDTH_2X);
    var srcToUse = capped1x || sourceSrc;

    bacSticky.image.src = srcToUse;
    if (capped1x && capped2x) {
      bacSticky.image.srcset = capped1x + ' 1x, ' + capped2x + ' 2x';
    } else {
      bacSticky.image.removeAttribute('srcset');
    }

    var alt = image.getAttribute('alt');
    if (alt) bacSticky.image.alt = alt;
  }

  function syncBacStickyButtonFromMain() {
    if (!bacMainSubmitButton || !bacSticky.button) return;

    var isSoldOut = dom.isAtcSoldOut(bacMainSubmitButton);
    var isDisabled =
      bacMainSubmitButton.disabled ||
      dom.isAtcDisabled(bacMainSubmitButton) ||
      isSoldOut;

    bacSticky.button.disabled = isDisabled;
    dom.setAtcState(bacSticky.button, {
      disabled: dom.isAtcDisabled(bacMainSubmitButton),
      soldout: isSoldOut,
      loading: dom.isAtcLoading(bacMainSubmitButton)
    });

    var mainLabel = bacMainSubmitButton.querySelector('[data-bac-atc-label]');
    var stickyLabel = bacSticky.button.querySelector('[data-bac-atc-label]');
    if (mainLabel && stickyLabel) {
      stickyLabel.innerHTML = mainLabel.innerHTML;
    }
  }

  function setBacStickyActive(isActive) {
    if (!bacSticky.bar) return;
    bacSticky.bar.classList.toggle('active', !!isActive);
  }

  function updateBacStickyBar(priceState) {
    if (!bacSticky.bar) return;

    var api = getDiscountApi();
    var formatPrice = api ? api.formatMoney.bind(api) : formatMoney;
    var payment = getBacStickyPaymentLabel();
    var pricing = getBacStickyPricing();
    var total = priceState && Number.isFinite(priceState.discountedTotal)
      ? formatPrice(priceState.discountedTotal)
      : pricing.current;
    var compareTotal = priceState && pricesDiffer(priceState.originalTotal, priceState.discountedTotal)
      ? formatPrice(priceState.originalTotal)
      : '';

    if (bacSticky.payment) bacSticky.payment.textContent = payment;
    if (bacSticky.titleSeparator) bacSticky.titleSeparator.hidden = !bacSticky.plan || !payment;
    if (bacSticky.total) bacSticky.total.textContent = total;
    if (bacSticky.size) bacSticky.size.textContent = getBacStickySizeText();
    if (bacSticky.crate) bacSticky.crate.textContent = getBacStickyCrateText();
    if (bacSticky.delivery) bacSticky.delivery.textContent = getBacStickyDeliveryText();
    if (bacSticky.charge) bacSticky.charge.textContent = getBacStickyChargeText();
    if (bacSticky.priceCurrent) bacSticky.priceCurrent.textContent = total;
    if (bacSticky.priceCompare) {
      bacSticky.priceCompare.textContent = compareTotal;
      bacSticky.priceCompare.hidden = !compareTotal;
    }
    if (bacSticky.priceBadge) {
      bacSticky.priceBadge.textContent = pricing.badge;
      bacSticky.priceBadge.hidden = !pricing.badge;
    }
    if (bacSticky.desktopCompare) {
      bacSticky.desktopCompare.textContent = compareTotal;
      bacSticky.desktopCompare.hidden = !compareTotal;
    }
    if (bacSticky.desktopBadge) {
      bacSticky.desktopBadge.textContent = pricing.badge;
      bacSticky.desktopBadge.hidden = !pricing.badge;
    }
    if (bacSticky.buttonTotal) bacSticky.buttonTotal.textContent = total;
    if (bacSticky.buttonCompare) {
      bacSticky.buttonCompare.textContent = compareTotal;
      bacSticky.buttonCompare.hidden = !compareTotal;
    }
    if (bacSticky.buttonDivider) {
      bacSticky.buttonDivider.hidden = !total || total === '-';
    }

    syncBacStickyImage();
    syncBacStickyButtonFromMain();
  }

  function setupBacStickyButtonMirror() {
    if (!bacMainSubmitButton || !bacSticky.button || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function() {
      syncBacStickyButtonFromMain();
    });
    observer.observe(bacMainSubmitButton, {
      attributes: true,
      attributeFilter: [
        'disabled',
        'data-bac-atc-disabled',
        'data-bac-atc-soldout',
        'data-bac-atc-loading'
      ],
      childList: true,
      characterData: true,
      subtree: true
    });
    syncBacStickyButtonFromMain();
  }

  function setupBacStickyVisibility() {
    if (!bacSticky.bar) return;

    var ctaAnchor =
      document.querySelector('[data-next-flow-btn]') ||
      (bacMainSubmitButton && bacMainSubmitButton.closest('.subscription-cta')) ||
      bacMainSubmitButton;

    if (!ctaAnchor) {
      setBacStickyActive(false);
      return;
    }

    var updateVisibilityFromRect = function() {
      var rect = ctaAnchor.getBoundingClientRect();
      setBacStickyActive(rect.bottom <= 0);
    };

    window.addEventListener('scroll', updateVisibilityFromRect, { passive: true });
    window.addEventListener('resize', updateVisibilityFromRect);
    updateVisibilityFromRect();
  }

  function initBacStickyBar() {
    if (!bacSticky.bar) return;

    if (bacSticky.toggle) {
      bacSticky.toggle.addEventListener('click', function(event) {
        event.preventDefault();
        setBacStickySummaryOpen(!bacStickySummaryOpen);
      });
    }
    if (bacSticky.summaryToggle) {
      bacSticky.summaryToggle.addEventListener('click', function(event) {
        event.preventDefault();
        setBacStickySummaryOpen(!bacStickySummaryOpen);
      });
    }
    if (bacSticky.button) {
      bacSticky.button.addEventListener('click', function(event) {
        if (
          !bacMainSubmitButton ||
          dom.isAtcDisabled(bacMainSubmitButton) ||
          dom.isAtcSoldOut(bacMainSubmitButton)
        ) {
          event.preventDefault();
          return;
        }
        bacMainSubmitButton.click();
      });
    }

    setupBacStickyButtonMirror();
    setupBacStickyVisibility();
  }

  // Recommended items add/remove + selected plan subtotal
  function updateTotalPrice() {
    var card = window.buildACrateFlow.getActivePlanCard
      ? window.buildACrateFlow.getActivePlanCard()
      : dom.getSelectedPlanCard();
    var body = card ? getPlanProductBodyForMode(card, getPurchaseMode()) : null;
    var api = getDiscountApi();
    var prices = body && api ? api.getPriceDisplayState(body) : null;

    var planDiscountedTotal = prices ? prices.discountedSubtotalDollars : getSelectedPlanPriceAmount();
    if (planDiscountedTotal <= 0) {
      planDiscountedTotal = cfg.basePrice;
    }
    var planOriginalTotal = prices && prices.hasSubtotalDiscount
      ? prices.originalSubtotalDollars
      : planDiscountedTotal;
    var hasSubtotalDiscount = prices && prices.hasSubtotalDiscount;
    var hasPerCrateDiscount = prices && prices.hasPerCrateDiscount;

    var perCrateDollars = 0;
    var perCrateCompareDollars = 0;
    var isBundle = isBundlePlanBody(body);
    if (prices) {
      perCrateDollars = prices.originalPerCrateDollars;
      perCrateCompareDollars = prices.originalPerCrateDollars;
      if (!isBundle && hasPerCrateDiscount) {
        perCrateDollars = prices.discountedPerCrateDollars;
      }
    } else if (body && api) {
      var baseCents = parseInt(body.getAttribute('data-bac-plan-base-price-cents'), 10);
      if (Number.isFinite(baseCents) && baseCents > 0) {
        perCrateDollars = api.calculatePerCrateCents(body, baseCents) / 100;
      }
    }
    if (perCrateDollars <= 0) {
      perCrateDollars = getSelectedPlanPerCrateAmount();
    }

    if (prices) {
      updateHeroStartingPrice(prices, body);
    }

    var totalWrap = document.querySelector('[data-addon-total-display]');
    var totalCompare = document.querySelector('[data-bac-total-compare]');
    var totalCurrent = document.querySelector('[data-bac-total-current]');
    var totalSuffix = cfg.totalSuffix || '';
    var totalLabel = cfg.totalLabel || '';

    // Addon total row always shows original per-crate price (never the discounted rate).
    var addonPerCrateDollars = prices
      ? prices.originalPerCrateDollars
      : (perCrateCompareDollars > 0 ? perCrateCompareDollars : perCrateDollars);

    if (totalCompare) {
      dom.setHidden(totalCompare, true);
    }

    if (totalCurrent && api) {
      totalCurrent.textContent =
        totalLabel + ': ' + api.formatMoney(addonPerCrateDollars) + totalSuffix;
      dom.setPriceDiscounted(totalCurrent, false);
    } else if (totalWrap) {
      totalWrap.textContent =
        totalLabel + ': $' + addonPerCrateDollars.toFixed(2) + totalSuffix;
    }

    applyAtcButtonLabel({
      discountedTotal: planDiscountedTotal,
      originalTotal: planOriginalTotal,
      hasDiscount: hasSubtotalDiscount
    });

    updateAllVisiblePlanCardPrices();
    updatePlanGiftDisplay();
    refreshAtcSubmitState();
    updateBacStickyBar({
      discountedTotal: planDiscountedTotal,
      originalTotal: planOriginalTotal,
      hasDiscount: hasSubtotalDiscount
    });
  }

  if (typeof BuildACrateCart !== 'undefined') {
    BuildACrateCart.register({
      getPurchaseMode: getPurchaseMode,
      getPlanProductBodyForMode: getPlanProductBodyForMode,
      readPlanCardSelection: readPlanCardSelection,
      isPlanCardConfiguredForPurchaseMode: isPlanCardConfiguredForPurchaseMode,
      getCrateRoot: function() { return crateRoot; },
      getAddedItemTypes: getAddedItemTypes,
      updateTotalPrice: updateTotalPrice
    });
  } else {
    console.error('[Build A Crate] build-a-crate-cart.js must load before build-a-crate-interactions.js');
  }

  // Add buttons for recommended items
  document.querySelectorAll('[data-add-item]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var productEl = btn.closest('[data-product-addon]');
      if (!productEl) return;

      if (bacDebugEnabled) {
        console.warn('[Build A Crate] Add-on ADD clicked', {
          itemId: productEl.getAttribute('data-item-id'),
          itemType: productEl.getAttribute('data-item-type'),
          expectedSpType: resolveSpTypeFromAddonTypes(
            getAddedItemTypes().concat([(productEl.getAttribute('data-item-type') || '').toLowerCase().trim()])
          ),
          name: productEl.querySelector('[data-bac-addon-name]') ? productEl.querySelector('[data-bac-addon-name]').textContent.trim() : ''
        });
      }

      var addBtn = productEl.querySelector('[data-add-item]');
      var removeBtn = productEl.querySelector('[data-remove-item]');

      productEl.setAttribute('data-added', 'true');

      if (removeBtn) {
        addBtn.style.display = 'none';
        removeBtn.style.display = 'inline-block';
        dom.setHidden(removeBtn, false);
      } else {
        addBtn.textContent = cfg.addedLabel;
        addBtn.disabled = true;
      }

      filterPlanCards({
        keepSelection: false,
        keepPayFrequency: true,
        trigger: 'addon-add',
        triggerDetail: {
          itemId: productEl.getAttribute('data-item-id'),
          itemType: productEl.getAttribute('data-item-type'),
          expectedSpType: getActiveSpType(),
          name: productEl.querySelector('[data-bac-addon-name]') ? productEl.querySelector('[data-bac-addon-name]').textContent.trim() : ''
        }
      });
      updateTotalPrice();
    });
  });

  // Remove buttons for recommended items
  document.querySelectorAll('[data-remove-item]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var productEl = btn.closest('[data-product-addon]');
      if (!productEl) return;

      if (bacDebugEnabled) {
        console.warn('[Build A Crate] Add-on REMOVE clicked', {
          itemId: productEl.getAttribute('data-item-id'),
          itemType: productEl.getAttribute('data-item-type'),
          name: productEl.querySelector('[data-bac-addon-name]') ? productEl.querySelector('[data-bac-addon-name]').textContent.trim() : ''
        });
      }

      var addBtn = productEl.querySelector('[data-add-item]');
      var removeBtn = productEl.querySelector('[data-remove-item]');

      addBtn.style.display = 'inline-block';
      addBtn.textContent = cfg.addLabel;
      addBtn.disabled = false;
      if (removeBtn) {
        removeBtn.style.display = 'none';
        dom.setHidden(removeBtn, true);
      }

      productEl.setAttribute('data-added', 'false');
      filterPlanCards({
        keepSelection: false,
        trigger: 'addon-remove',
        triggerDetail: {
          itemId: productEl.getAttribute('data-item-id'),
          itemType: productEl.getAttribute('data-item-type'),
          expectedSpType: getActiveSpType(),
          name: productEl.querySelector('[data-bac-addon-name]') ? productEl.querySelector('[data-bac-addon-name]').textContent.trim() : ''
        }
      });
      updateTotalPrice();
    });
  });

  // Size selection handlers
  document.querySelectorAll('[data-item-size]').forEach(function(selector) {
    selector.addEventListener('change', function() {
      const product = this.closest('[data-product-addon]');
      if (product) {
        product.dataset.selectedSize = this.value;
      }
      refreshAtcSubmitState();
    });
  });

  // Add to cart — build-a-crate-cart.js only (not subscription-common.js)
  const addToCartBtn = document.querySelector('[data-submit-build-a-crate]');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(event) {
      var canSubmit = window.buildACrateFlow.canSubmitBuildACrate;
      var syncCheckout = window.buildACrateFlow.syncBuildACrateCheckout;
      var addToCart = window.buildACrateFlow.addBuildACrateToCart;

      if (!canSubmit || !canSubmit()) {
        bacDebugLog('Add to cart blocked — incomplete selection');
        return;
      }
      if (!syncCheckout || !syncCheckout()) {
        bacDebugLog('Add to cart blocked — could not sync checkout state');
        return;
      }
      if (!addToCart) {
        console.error('[Build A Crate] build-a-crate-cart.js is not loaded');
        return;
      }

      var btn = event.currentTarget;
      var addText = btn.querySelector('[data-bac-atc-label]');
      dom.setAtcState(btn, { loading: true, disabled: true });
      if (addText && cfg.atcLoading) {
        addText.textContent = cfg.atcLoading;
      }

      addToCart()
        .catch(function(err) {
          bacDebugLog('Add to cart failed', err);
          console.error('[Build A Crate] Add to cart failed:', err.message || err);
          dom.setAtcState(btn, { loading: false });
          refreshAtcSubmitState();
          updateTotalPrice();
        });
    });
  }

  function syncDomStateFromMarkup() {
    document.querySelectorAll('[data-plan-card]').forEach(function(card) {
      var slide = card.closest('.swiper-slide');
      var visibilityTarget = slide || card;
      var hiddenAttr = visibilityTarget.getAttribute('data-bac-hidden');
      if (hiddenAttr === 'true' || hiddenAttr === 'false') {
        dom.setHidden(card, hiddenAttr === 'true');
      } else if (!visibilityTarget.hasAttribute('data-bac-hidden')) {
        dom.setHidden(card, visibilityTarget.classList.contains('d-none'));
      }
      if (!card.hasAttribute('data-bac-plan-selected')) {
        dom.setPlanSelected(card, card.classList.contains('selected'));
      }
    });

    document.querySelectorAll('[data-bac-thumbnail-item]').forEach(function(thumb) {
      if (!thumb.hasAttribute('data-bac-thumbnail-visible')) {
        dom.setThumbnailVisible(thumb, thumb.classList.contains('visible'));
      }
      if (!thumb.hasAttribute('data-bac-thumbnail-active')) {
        dom.setThumbnailActive(thumb, thumb.classList.contains('active'));
      }
    });

    document.querySelectorAll('[data-submit-build-a-crate], [data-sticky-submit-build-a-crate]').forEach(function(btn) {
      if (!btn.hasAttribute('data-bac-atc-disabled')) {
        btn.setAttribute('data-bac-atc-disabled', btn.disabled ? 'true' : 'false');
      }
      if (!btn.hasAttribute('data-bac-atc-soldout')) {
        btn.setAttribute('data-bac-atc-soldout', btn.classList.contains('soldout') ? 'true' : 'false');
      }
      if (!btn.hasAttribute('data-bac-atc-loading')) {
        btn.setAttribute('data-bac-atc-loading', btn.classList.contains('loading') ? 'true' : 'false');
      }
    });
  }

  // Initialize
  syncDomStateFromMarkup();
  applyPurchaseModeToPlanCards(getPurchaseMode());
  if (bacFreqRadios.length) {
    updateBacShipFrequencyUi();
  } else {
    filterPlanCards({ keepSelection: false, trigger: 'init' });
  }
  logPlanFilterState('init-complete');
  function initBacGallery(attempt) {
    if (typeof attempt !== 'number') attempt = 0;
    if (attempt === 0) {
      bacActiveGalleryKey = null;
      bacVisibleGallerySignature = null;
      showImagesForCrateType(defaultCrate);
    } else {
      activateBacGalleryForCrate(defaultCrate);
    }
    if (bacMainGallery && !bacMainGallery.swiper && attempt < 20) {
      window.setTimeout(function() {
        initBacGallery(attempt + 1);
      }, 120);
    }
  }
  initBacGallery();
  updateTotalPrice();
  syncInsideCrateAccordionFromSelections();
  bindInsideCrateAccordionRefresh();
  updatePlanGiftDisplay();
  syncFlowProductTypeFromPlanCard();
  initBacStickyBar();
  refreshAtcSubmitState();
});

window.addEventListener('pageshow', function(event) {
  var navEntry = performance.getEntriesByType('navigation')[0];
  if (event.persisted || (navEntry && navEntry.type === 'back_forward')) {
    window.location.reload();
  }
});
